import { SerializedToken } from 'config/constants/types';
import { Chain } from 'state/types';
import _ from 'lodash';
import { TokenDto } from '@iddy/time-machine';

export const getImageUrlFromToken = (symbol: string, type: 'tokens' | 'dex' | 'chain' = 'tokens', solid?:boolean, disable?: boolean) => `/images/${type}/${_.toLower(symbol)}${solid?'-solid':''}${disable?'-disable':''}.${(type === 'tokens') ? 'png': 'svg'}`

// TODO: confirm this domain can use for this project and the icon image is not missing
export const getImageUrlFromTokenDto = (token:TokenDto) => `/images/tokens/${_.toLower(token?.symbol)}.png`